import SimpleTab from "@/components/simpletable/SimpleTab.vue";
import SportsmanService from "@/utils/services/sportsmanService.js";
import DisciplineService from "@/utils/services/disciplineService.js";
import ResultService from "@/utils/services/resultService.js";
import FormSelectVue from "./FormSelectVue.vue";

export default {
  name: "ResultTeam",
  props: {
    fedId: {
      type: Number,
      default: 0
    },
    sportKindId: {
      type: Number,
      default: 0
    },
    ekpDataId: {
      type: Number,
      default: 0
    }
  },
  components: {SimpleTab, FormSelectVue},
  data() {
    return {
      dropdownPosition: { top: 0, left: 0, width: 0 },
      items: [],
      columns: [
        {key: 'people', label: 'ФИО'},
        {key: 'discipline', label: 'Дисциплина'},
        {key: 'place', label: 'Место'},
        {key: 'description', label: 'Примечание'},
        {key: 'edit_field', label: ''},
      ],
      heightTab: "60vh",
      modalPeopleOpened: false,
      editPeople: {
        sportsmanId: null
      },
      peoples: [],
      columnsPeople: [
        {key: 'fio', label: 'ФИО'}
      ],
      selectedPeopleId: 0,
      rowIndex: 0,
      places: [
        {
          id: 1,
          name: 'Золото'
        },
        {
          id: 2,
          name: 'Серебро'
        },
        {
          id: 3,
          name: 'Бронза'
        }
      ],
      disciplines: []
    }
  },
  created() {
    this.loadPeoples()
    this.loadDisciplines()
    this.loadEventResult()
  },
  methods: {
    addPeople() {
      let people = {
        id: 0,
        sportsmanId: null,
        disciplineId: null,
        placeId: null,
        description: '',
        ekpDataId: this.ekpDataId
      };
      this.items.push(people);
    },
    removePeople(index) {
      this.items.splice(index, 1);
    },
    loadPeoples() {
      this.peoples = []
      SportsmanService.getSportsmanOptions({federationId: this.fedId})
      .then(response => {
        this.peoples = response.data
      })
    },
    loadDisciplines() {
      DisciplineService.getDisciplineListByFederation(this.fedId)
      .then(response => {
        this.disciplines = response.data
      })
    },
    showPeopleDialog(index) {
      this.rowIndex = index
      this.modalPeopleOpened = !this.modalPeopleOpened;
    },
    selectPeople() {
      this.items[this.rowIndex].sportsmanId = this.selectedPeopleId
      this.modalPeopleOpened = !this.modalPeopleOpened;
    },
    saveResult() {
      ResultService.saveResult(this.ekpDataId, this.items)
      .then((res) => {
        this.items = res.data
      })
    },
    closeModal() {
      this.$emit("closeModal")
    },
    loadEventResult() {
      ResultService.getEventResult(this.ekpDataId)
      .then((res) => {
            this.items = res.data;
          }
      )
    }
  }
}
